import { model, Model } from 'mst-collection';
import { types } from 'mobx-state-tree';

export class CourseUserStats extends Model({
  isStarted: types.boolean,
  isCompleted: types.boolean,
  currentVideoId: types.maybeNull(types.number),
}) {
  setIsStarted(value: boolean) {
    this.isStarted = value;
  }

  setCurrentVideoId(value: number) {
    this.currentVideoId = value;
  }

  setIsCompleted(value: boolean) {
    this.isCompleted = value;
  }
}

export const CourseUserStatsModel = model(CourseUserStats);
